// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetBetsPositionService {
  /** Идентификатор сервиса **/
  serviceId: EServiceId;
  /** Ставка на уровне продвижения **/
  bet: number;
}
export enum EServiceId {
  /** Платное **/
  'Paid' = 'paid',
  /** Премиум-объявление **/
  'Premium' = 'premium',
  /** Топ 3 **/
  'Top3' = 'top3',
  /** Выделение цветом **/
  'Highlight' = 'highlight',
  /** Подмена номера, Calltracking, оно же "защита номера" **/
  'Calltracking' = 'calltracking',
  /** Бесплатное **/
  'Free' = 'free',
  /** Аукцион **/
  'Auction' = 'auction',
}
